/* Stato della barra dal pulsante/form Focal corrente; nessuna Cart API duplicata. */
(() => {
  if (!customElements.get('extro-sticky-atc')) {
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('[data-extro-product-hover]');
        if (!this.scope) return;
        this.button = this.querySelector('button');
        this.label = this.querySelector('.sticky-atc-button-content');
        this.price = this.querySelector('.sticky-atc-price');
        this.onUpdate = () => {
          if (this.updateQueued) return;
          this.updateQueued = true;
          queueMicrotask(() => { this.updateQueued = false; if (this.isConnected) this.refresh(); });
        };
        this.onClick = () => {
          this.refresh();
          if (this.button.disabled) return;
          if (this.canAdd) {
            this.button.disabled = true;
            this.main.click(); // Quantita', proprieta', validazione e cassetto originali.
            this.onUpdate();
          } else {
            const picker = this.scope.querySelector('variant-picker');
            if (!picker) return;
            picker.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
            const control = picker.querySelector('button.select, input:checked, input[type="radio"], select, a[href]');
            control?.focus({ preventScroll: true });
          }
        };
        this.intersection = new IntersectionObserver(entries => {
          for (const entry of entries) if (entry.target === this.main) this.setVisible(!entry.isIntersecting);
        });
        this.buttonObserver = new MutationObserver(this.onUpdate);
        this.sizeObserver = new ResizeObserver(() => {
          if (this.classList.contains('is-visible')) document.documentElement.style.setProperty('--cart-notification-offset', `${this.clientHeight}px`);
        });
        this.sizeObserver.observe(this);
        this.scope.addEventListener('variant:change', this.onUpdate);
        this.scope.addEventListener('product:rerender', this.onUpdate, true);
        this.scope.addEventListener('extro:variant-pending', this.onUpdate);
        this.button.addEventListener('click', this.onClick);
        this.frame = requestAnimationFrame(() => this.refresh());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.intersection?.disconnect();
        this.buttonObserver?.disconnect();
        this.sizeObserver?.disconnect();
        document.documentElement.style.removeProperty('--cart-notification-offset');
        this.scope?.removeEventListener('variant:change', this.onUpdate);
        this.scope?.removeEventListener('product:rerender', this.onUpdate, true);
        this.scope?.removeEventListener('extro:variant-pending', this.onUpdate);
        this.button?.removeEventListener('click', this.onClick);
      }
      setVisible(visible) {
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
        this.inert = !visible;
        if (visible) document.documentElement.style.setProperty('--cart-notification-offset', `${this.clientHeight}px`);
        else document.documentElement.style.removeProperty('--cart-notification-offset');
      }
      refresh() {
        const main = this.scope.querySelector('[data-product-add-to-cart-button]');
        if (main !== this.main) {
          this.intersection.disconnect();
          this.buttonObserver.disconnect();
          this.main = main;
          if (main) {
            this.intersection.observe(main);
            this.buttonObserver.observe(main, { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
          }
        }
        if (!main) { this.setVisible(false); return; }
        const busy = main.getAttribute('aria-busy') === 'true' || this.scope.hasAttribute('data-extro-variant-pending');
        const selectedId = main.form?.elements.namedItem('id')?.value;
        this.canAdd = main.dataset.variantAvailable === 'true' && !!selectedId && selectedId === main.dataset.variantId && !main.disabled;
        this.button.classList.toggle('can-add-to-cart', this.canAdd);
        const picker = this.scope.querySelector('variant-picker');
        const text = this.canAdd ? 'AGGIUNGI AL CARRELLO >' : picker ? 'SCEGLI TAGLIA/COLORE >' : 'NON DISPONIBILE';
        if (this.label.textContent !== text) this.label.textContent = text;
        this.button.disabled = busy || (!this.canAdd && !picker);
        this.button.classList.toggle('is-loading', busy);
        this.button.setAttribute('aria-busy', String(busy));
        if (!this.canAdd && picker?.id) this.button.setAttribute('aria-controls', picker.id);
        else this.button.removeAttribute('aria-controls');
        const amount = main.dataset.variantPrice;
        this.price.hidden = amount === '' || amount == null;
        if (!this.price.hidden) {
          const formatted = new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(Number(amount) / 100);
          if (this.price.textContent !== formatted) this.price.textContent = formatted;
        }
      }
    }
    customElements.define('extro-sticky-atc', StickyAtc);
  }

  if (!customElements.get('extro-paypal-message')) {
    class PaypalMessage extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.product-form');
        this.onVariant = event => {
          const message = this.querySelector('[data-pp-message]');
          if (!message) return;
          const variant = event.detail.variant;
          this.style.visibility = variant ? '' : 'hidden';
          if (!variant || Number(message.dataset.ppAmount) === variant.price / 100) return;
          // Il SDK osserva data-pp-amount: non ricreare iframe o richiamare render().
          const height = message.getBoundingClientRect().height;
          if (height > 0) message.style.minHeight = `${height}px`;
          message.dataset.ppAmount = (variant.price / 100).toFixed(2);
        };
        this.scope?.addEventListener('variant:change', this.onVariant);
        this.resize = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (this.width != null && Math.abs(width - this.width) > 1) this.querySelector('[data-pp-message]')?.style.removeProperty('min-height');
          this.width = width;
        });
        this.resize.observe(this);
      }
      disconnectedCallback() {
        this.scope?.removeEventListener('variant:change', this.onVariant);
        this.resize?.disconnect();
      }
    }
    customElements.define('extro-paypal-message', PaypalMessage);
  }
})();
